import { SessionModule } from "./session.module";

export class SessionsModule {
  initialize() {
    this.sessionBlocks = document.querySelectorAll(".sessions-container");

    if (!this.sessionBlocks) return;

    this.sessionBlocks.forEach((sessionBlock) => {
      new SessionModule(sessionBlock);
    });
  }
}